import "../../challenges/Challenges.css"
import React, { useState,useEffect } from "react";
import "../../myProjects/Myprojects.css"
import { FileUploader } from 'react-drag-drop-files';
import api from "views/auth/Api";
import { message } from 'antd';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../../../configs/AppConfig';
import { FaRegWindowClose } from "react-icons/fa";
import { Link } from "react-router-dom";




const TrainingEdit = () => {
  const [resources , setResources] = useState([]); 
  const [trainingName , setTrainingName] = useState(); 
  const [editId, setEditId] = useState(null);
console.log(editId,"editIdeditId")
  const [formInputs , setFormInputs] = useState({
          title:"",
          url:"",
        });
  const [delOpen , setDelOpen] = useState(false)
const [delOneId , setDelOneId] = useState(null)
  const { id } = useParams();
  const navigate = useNavigate();

  const successAddResources = () => {
           message.success('Your Resources Added Successfully');
          };
          
  const delSuccess = ()=>{
    message.success('Delete Done');
  }

  const successEditResources = () => {
           message.success('Your Resources Edit Successfully');
          };
  
  const successSaved = () => {
             message.success('Your Training Saved Completely');
            };
  

     useEffect(() => {
     api.get(`${API_BASE_URL}training/${id}`)
      .then((response) => {  
        if (!response.data) {
          navigate(`/auth/not-found/`);
        }
    setResources(response.data?.resources)
    setTrainingName(response.data?.name)
      })
      .catch((error) => {
        console.error('Error fetching card:', error);
      });
  }, [navigate,id]);


const isFormValid = formInputs.title.trim() !== '' && formInputs.url.trim() !== '';

    const handleAddRes = (event) => {
    event.preventDefault();
      addResource();
        setFormInputs({
          title:"",
          url:"",
        })}

      const addResource = async () => {  
       await api.post(`${API_BASE_URL}training-resources`,{
          title: formInputs.title,
          url: formInputs.url,
          training: id,
          })
        .then(function (response) {
                  console.log("handlesubmitffff  ", response.data)
                  successAddResources()
                  setResources(response.data?.resources);
              // setData(response.data)
        }).catch(error => {
          console.log("handlesubmit error for blog get ", error)
        });   
          }

 const confirmDel = async (id)=>{
    if (id) {
      setDelOpen(false)
     await api.delete(`${API_BASE_URL}training-resources/${id}`)
      .then(function (response) {
          setResources(response.data?.resources);
          delSuccess();
      }).catch(error => {
        console.log("handlesubmit error for blog ", error)
      });
  }
 }

const editOne = async (event) => { 
      event.preventDefault();
       await api.patch(`${API_BASE_URL}training-resources/${editId}`,{
          title: formInputs.title,
          url: formInputs.url,
          training : id
          })
        .then(function (response) {
          setResources(response.data?.resources);
          successEditResources()
        }).catch(error => {
          console.log("handlesubmit error for blog get ", error)
        });   
          }

const editInfo =(resource)=>{
  if(editId === resource.id){
      setFormInputs({
      title: "",
      url: "",
    });
    setEditId(null)
  }
  else{
        setFormInputs({
      title: resource.title,
      url: resource.url,
    });
    setEditId(resource.id)

  }
 }


  return (
    <div className="h-fit w-full pt-10"> 
    <h2 className="addLibrary-h2">{trainingName}</h2> 
         {resources ? 
                <div className="model3d-cards-add flex-wrap" >
                   {resources.map(resource =>
      <div className="card-lesson resCardDel"
        style={{
    border: resource.id === editId 
      ? "2px solid red" 
      : "2px solid rgb(233, 236, 239)"
  }}
          onClick={()=> {editInfo(resource)}}
          >
     {/* <MdOutlineDeleteForever className="deleteLib ml-auto" onClick={()=> {delId(resource.id)}}/> */}
        <h2 className="h2CardRes">{resource.title}</h2>
            </div>   )}
                </div> 
          : null}

   <form className="addChallenge mb-[100px]"> 
      <div className="addChallengeFlex mt-6">
         <div className="addChallengeLR">
    <div className="addCHInpts">
            <label htmlFor="LessonName">Lesson Name</label>
            <input type="text" className="inputWidth" id="LessonName" value={formInputs.title} placeholder="Enter resource Name" 
            onChange={(e) =>setFormInputs({...formInputs, title: e.target.value})}/>
          </div>

    </div>
        <div className="addChallengeLR">
        
    <div className="addCHInpts">
            <label htmlFor="link">Link</label>
            <input type="text" className="inputWidth" id="link" value={formInputs.url} placeholder="Enter Link"
             onChange={(e) =>setFormInputs({...formInputs, url: e.target.value})}/>
           </div> 
          </div>
</div>

        <div className="flex justify-center gap-x-4 mt-[25px]">
       {!editId ? <button onClick={handleAddRes} disabled={!isFormValid} className="add-plate w-[100px]">Add </button> : null}
      { editId ?  <button onClick={editOne} disabled={!isFormValid} className="add-plate w-[100px]">Edit </button> : null}
      <Link to={`/admin/training/voxel/${id}`}> <button onClick={successSaved} className="add-plate w-[100px]">Save</button> </Link>
        </div>
       </form> 
               { delOpen ? <div className="modal"> <div id="delPopup">
                   <button id="popIcon" onClick={()=>{setDelOpen(false)}}>
                   <FaRegWindowClose className="w-full h-full	"/>
                 </button>
                 <div id="helpText"><span >Do you want to delete this one?</span>
                  <p className="delResName">( {delOneId.title} )</p>
                  </div>
                 <div className="resYesNo">
                 <button className="yesorno" onClick={() => {confirmDel(delOneId.id)}}> Yes </button> 
                 <button className="yesorno" onClick={()=>{setDelOpen(false)}}> No </button>  </div>
                   </div></div> : null}
    </div>
  );
};

export default TrainingEdit;
